import { LogoMark } from '../ui/LogoMark'

export function AppHeader() {
  return (
    <header className="sticky top-0 z-30 border-b border-white/10 bg-ink/95 text-white shadow-sm backdrop-blur">
      <div className="mx-auto flex h-20 w-full max-w-[1500px] items-center justify-between gap-4 px-4 sm:px-6 lg:px-8 [&_span]:text-white">
        <LogoMark />
        <div className="hidden min-w-0 text-right sm:block">
          <p className="text-[0.65rem] font-bold uppercase tracking-[0.14em] text-white/45">
            Directorio empresarial
          </p>
          <p className="text-sm font-semibold text-white/85">Empresas, contactos y sitios web</p>
        </div>
      </div>
    </header>
  )
}
